import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SubEntityType } from "../../../types/ScientificModule";

const initialState: SubEntityType = {
    id: "",
    idEntity: "",
    description: "",
    status: false,
};

const subEntitiesSlice = createSlice({
    name: "SubEntities",
    initialState,
    reducers: {
        setSubEntitiesData: (state, action: PayloadAction<SubEntityType>) => ({ ...state, ...action.payload }),
        resetSubEntitiesData: () => ({ ...initialState }),
    },
});

export const { setSubEntitiesData, resetSubEntitiesData } = subEntitiesSlice.actions;

export default subEntitiesSlice.reducer;
